<div class="spinner">
  <svg
    height="60"
    viewBox="0 0 58 60"
    width="58"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      class="spinner__icon"
      d="m29 1 28 14.3997949v28.7995899l-28 14.399795-28-14.399795v-28.7995899z"
      fill="none"
      stroke="#ff8700"
    />
  </svg>
  <div class="spinner__label">Loading</div>
</div>
